import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsNotLinkedToUserCacheKey } from "./constants";

// Generic read for custom objects of a type that are NOT yet linked to a user
// (tenant Postgres, b2b_ea). The caller supplies type_name / rel_kind, so this
// serves any CO type — the account-specific adaptation lives in the consuming hook.
export interface CustomObjectsNotLinkedToUserApiProps {
  typeName: string;
  userIdentifier: string;
  relKind: string;
  searchTerm: string;
  start: number;
  limit: number;
}

export interface CustomObjectNotLinkedRow {
  id: string;
  external_id: string;
  display_name: string | null;
}

export interface CustomObjectsNotLinkedToUserResponse {
  hits: number;
  results: CustomObjectNotLinkedRow[];
}

export const getCustomObjectsNotLinkedToUser = reactQueryFetcherAdapter(
  customObjectsNotLinkedToUserCacheKey,
  (
    signal,
    { typeName, userIdentifier, relKind, searchTerm, start, limit }: CustomObjectsNotLinkedToUserApiProps
  ): Promise<CustomObjectsNotLinkedToUserResponse> => {
    return fetch<CustomObjectsNotLinkedToUserResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/not_linked_to_user/${encodeURIComponent(userIdentifier)}`,
      "GET",
      {
        rel_kind: relKind,
        search_term: searchTerm,
        start,
        limit,
      },
      { signal }
    );
  }
);
